import { Card, CardProps } from "@heroui/react";
import clsx from "clsx";

export const BlurredCard = ({ children, className, ...rest }: CardProps) => {
  return (
    <Card isBlurred className={clsx("bg-default-100/50", className)} {...rest}>
      {children}
    </Card>
  );
};
